import React from 'react';
import './Partners.css';

const Partners = () => {
  const universities = [
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/66e95761d625d2f5108ee791_western-sydney.avif"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/66d5a3b7ceb7986db3009fb1_algonoquin-university-green-logo.svg"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/66d5a3b70d8dcc0fcbde40a2_cape-breton-university-logo.avif"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/66e95a994d433ab0e99c69ea_latrobe-university.avif"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/66d5a3b8520e5b41ba2f7211_toronto-university-logo.svg"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/68970e13f956659d7974a1af_university-of-alberta.avif"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/66d5a3b7a935ad183c86047f_crandall-university-logo.svg"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/68a57ff81f30d9e543562677_university-of-calgary-continuing-education.avif"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/689700dce5fd935483539704_sydney-met-CSB-Study-Abroad.avif"},
    {link: "https://cdn.prod.website-files.com/66c7162ff69c4a34dabec261/670fbaf42f60627d5229dd87_dalhousie-university.avif"},
  ];

  // Duplicate universities to create seamless loop
  const duplicatedUniversities = [...universities, ...universities, ...universities, ...universities];

  return (
    <section className="partners section">
      <h2 className="section-title">Our Partners</h2>
      <div className="container">
        <div className="partners-slider">
          <div className="partners-track">
            {duplicatedUniversities.map((university, index) => (
              <div key={index} className="university-card">
                <img src={university.link} alt="University Logo" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Partners;
